import { useSuspenseQuery } from '@tanstack/react-query';

import { getPayReceipt } from '../api';

/**
 * @typedef {Object} PayReceiptParams
 * @property {string} hspId - 병원 ID
 * @property {string} mpiKey - 환자 키
 * @property {string} receivePaymentId - 수납 ID
 * @property {string} medicalInsuranceType - 보험 유형
 */

/**
 * @param {PayReceiptParams} params
 * @returns {import('@tanstack/react-query').UseSuspenseQueryResult}
 */
export const useGetPayReceipt = (params) => {
  return useSuspenseQuery({
    queryKey: ['PayReceipt', params],
    queryFn: () => getPayReceipt(params),
  });
};
